import React, { useEffect } from "react"
import types from "prop-types"
import { useDispatch } from "react-redux"
import { useHiddenSidebar, useReportIndexSettings } from "hooks"
import { setReports } from "reduxSlices/reportIndexSlice"
import {
  SOLUTION_REPORT_TYPE,
  SUBMISSION_REPORT_TYPE,
  SURVEY_REPORT_TYPE,
  TASK_REPORT_TYPE,
} from "utils/reportHelpers"
import withReduxProvider from "shared/withReduxProvider"
import ReportsContent from "./Content/ReportsContent"
import ReportIndexSidebar from "./Sidebar"

const FormSubmissionReport = ({
  formSubmissionReports = [], solutionLevelReports = [], surveyReports = [], taskReports = [],
}) => {
  const dispatch = useDispatch()
  const { hiddenSidebar, toggleSidebar } = useHiddenSidebar()

  useEffect(
    () => {
      dispatch(setReports({
        [SUBMISSION_REPORT_TYPE]: formSubmissionReports,
        [SOLUTION_REPORT_TYPE]: solutionLevelReports,
        [SURVEY_REPORT_TYPE]: surveyReports,
        [TASK_REPORT_TYPE]: taskReports,
      }))
    },
    [dispatch, formSubmissionReports, solutionLevelReports, surveyReports, taskReports],
  )

  useReportIndexSettings()

  return (
    <>
      <ReportIndexSidebar hiddenSidebar={hiddenSidebar} />
      <ReportsContent
        hiddenSidebar={hiddenSidebar}
        toggleSidebar={toggleSidebar}
      />
    </>
  )
}

FormSubmissionReport.propTypes = {
  formSubmissionReports: types.arrayOf(types.object),
  solutionLevelReports: types.arrayOf(types.object),
  surveyReports: types.arrayOf(types.object),
  taskReports: types.arrayOf(types.object),
}

export default withReduxProvider(FormSubmissionReport)
